/* eslint-disable strict */

"use client";
import React from "react";
import { HttpLink, ApolloLink } from "@apollo/client";
import {
  ApolloNextAppProvider,
  ApolloClient,
  SSRMultipartLink,
  InMemoryCache,
} from "@apollo/client-integration-nextjs";

const createClient = () => {
  const httpLink = new HttpLink({
    uri: "/api/graphql",
    fetchOptions: { cache: "no-store" },
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${process.env.SCEV_API_KEY}`,
    },
  });

  return new ApolloClient({
    cache: new InMemoryCache(),
    link:
      typeof window === "undefined"
        ? ApolloLink.from([
            new SSRMultipartLink({
              stripDefer: true,
            }),
            new HttpLink({
              uri: process.env.GRAPHQL_URL,
              fetchOptions: { cache: "no-store" },
              credentials: "include",
              headers: {
                authorization: `Bearer ${process.env.SCEV_API_KEY}`,
                "Content-Type": "application/json",
              },
            }),
          ])
        : httpLink,
  });
};

export const SCEVApolloWrapper = ({
  children,
  jwt,
  clientName,
  hermesToken,
  hermesURL,
}: React.PropsWithChildren<{
  jwt: string | undefined;
  clientName?: string;
  hermesToken?: string;
  hermesURL?: string;
}>) => {
  const makeClient = React.useCallback(
    () => createClient(),
    [clientName, hermesToken, hermesURL, jwt]
  );
  return (
    <ApolloNextAppProvider makeClient={makeClient}>
      {children}
    </ApolloNextAppProvider>
  );
};
